import {MdCheckBox, MdCheckBoxOutlineBlank} from 'react-icons/md';
import {COLOR_LINK_1} from '../../../../../config/constants/colorCodes';
import {cn} from '../../../../../lib/classname';
import {TagForEngineer} from './TagForEngineer';

export const CheckboxInputForFilter: React.FC<{
  inputId: string;
  checked: boolean;
  onChange: () => void;
  labelText: string;
  hasForEngineer?: boolean;
}> = ({inputId, checked, onChange, labelText, hasForEngineer = false}) => {
  return (
    <div className={`w-full px-4  py-4 rounded-4 ${checked && 'bg-secondary'}`}>
      <label
        htmlFor={inputId}
        className={'flex cursor-pointer items-center text-base'}
      >
        {checked ? (
          <MdCheckBox fill="white" size={15} className="mr-8  cursor-pointer" />
        ) : (
          <MdCheckBoxOutlineBlank
            fill={COLOR_LINK_1}
            size={15}
            className="mr-8 cursor-pointer"
          />
        )}
        <input
          type="checkbox"
          id={inputId}
          className="hidden"
          checked={checked}
          onChange={onChange}
        />
        <span
          className={cn({
            'text-white': checked,
          })}
        >
          {labelText}
          {hasForEngineer && <TagForEngineer checked={checked} />}
        </span>
      </label>
    </div>
  );
};
